'use client'

import { useEffect, useId, useState } from 'react'
import { isPurMode } from '@/utils/app/paid'
import styles from './Prodo.module.scss'
import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies'

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    PRODO: any
  }
}

const Prodo = ({
  prodoSlotId,
  prodoSlotIdWebview,
  prodoType,
  isin,
  wkn,
  cookies,
  webview,
}: {
  prodoSlotId: string
  prodoSlotIdWebview?: string
  prodoType: 'default' | 'noIsin'
  isin?: string
  wkn?: string
  cookies: RequestCookie[]
  webview: boolean
}) => {
  const slotId = webview && prodoSlotIdWebview ? prodoSlotIdWebview : prodoSlotId
  const elementId = useId()
  const [showDisclaimer, setShowDisclaimer] = useState(false)

  const loadScript = (): void => {
    const id = 'prodoScript'
    let scriptElem = window && window.document && (window.document.getElementById(id) as HTMLScriptElement)

    if (!scriptElem) {
      scriptElem = document.createElement('script')
      scriptElem.type = 'text/javascript'
      scriptElem.id = id
      scriptElem.async = true
      scriptElem.src =
        'https://prodo-api.ariva-services.de/clientjs/ProdoClient.js?' + Math.random() * 10000000000000000000
      scriptElem.onload = function () {
        const event = new Event('prodoLoaded')
        window.dispatchEvent(event)
      }
      document.head.appendChild(scriptElem)
    }
  }

  useEffect(() => {
    if (!isPurMode(cookies)) {
      window.addEventListener(
        'prodoLoaded',
        () => {
          if (window.PRODO && !(prodoType === 'default' && !isin && !wkn)) {
            const prodo = window.PRODO
            prodo.adSlotId(slotId)
            prodo.elementId(elementId)
            prodo.removeOuterElementIfEmpty(false)
            prodo.removeOuterDisclaimerIfEmpty(true)
            prodo.userInterestDerivativeTypeIds([])
            if (prodoType === 'noIsin') {
              prodo.impactingIsins([])
            } else {
              if (isin) prodo.impactingIsins([isin])
              if (wkn && !isin) prodo.impactingIsins([wkn])
            }

            prodo.loadAdvertisement(function () {
              const prodoElem = document.getElementById(elementId)
              if (prodoElem?.shadowRoot) {
                const ankerElem1 = prodoElem.shadowRoot.querySelector('a[href="#footer"]') as HTMLAnchorElement
                const ankerElem2 = prodoElem.shadowRoot.querySelector('a[href="#foo"]') as HTMLAnchorElement
                if (ankerElem1) {
                  ankerElem1.onclick = function () {
                    setShowDisclaimer(true)
                    return false
                  }
                }
                if (ankerElem2) {
                  ankerElem2.onclick = function () {
                    setShowDisclaimer(true)
                    return false
                  }
                }
              }
            })
          }
        },
        false,
      )
      loadScript()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.wrapper}>
      <div id={elementId}></div>

      {showDisclaimer && (
        <div className={styles.disclaimer}>
          <button onClick={() => setShowDisclaimer(false)}>X</button>
          <strong>Werbehinweise:</strong>
          <span>
            Die Billigung des Basisprospekts durch die Bundesanstalt für Finanzdienstleistungsaufsicht ist nicht als
            ihre Befürwortung der angebotenen Wertpapiere zu verstehen. Wir empfehlen Interessenten und potenziellen
            Anlegern den Basisprospekt und die Endgültigen Bedingungen zu lesen, bevor sie eine Anlageentscheidung
            treffen, um sich möglichst umfassend zu informieren, insbesondere über die potenziellen Risiken und Chancen
            des Wertpapiers.{' '}
            <strong>
              Warnhinweise: Sie sind im Begriff, ein Produkt zu erwerben, das nicht einfach ist und schwer zu verstehen
              sein kann.
            </strong>
          </span>
        </div>
      )}
    </div>
  )
}

export default Prodo
